import React from 'react';
import Layout from '../components/Layout';


import ScrollingText from '../components/lettersslider';
import ServiceComponent from '../components/servicedescrpition';
import ComponentWithCards from '../components/serviceheadings';
import OurService from '../components/servicepage/ourservice';
import ContactForm from '../components/servicecontact';
import Coursework from '../components/courseworkheader';
import CourseworkServices from '../components/courseworkservice';
import useScrollTransition from '../useScrollTransition';


const CourseworkPage = () => {
  useScrollTransition();
  return (
    <Layout>
        <Coursework/>
        
        <ScrollingText/>
        <CourseworkServices/>
        <ServiceComponent/>
      <ComponentWithCards/>
      <OurService/>
      <ContactForm/>
        
    </Layout>
  );
};

export default CourseworkPage;